
import Vue from 'vue';
import { Modal, ModalTitle, Button, ModalActions } from '@descomplica/vue-components';
import i18n from '@/i18n';
import Enrollments from '@/services/Enrollments';

interface Data {
  isActive: Boolean;
}

export default Vue.extend({
  components: {
    Modal,
    ModalTitle,
    ModalActions,
    Button,
  },
  props: {
    title: {
      type: String,
      default: i18n.t('trial.titleModalExpired'),
    },
    subtitle: {
      type: String,
      default: i18n.t('trial.subTitleModalExpired'),
    },
  },
  data(): Data {
    return {
      isActive: false,
    };
  },
  computed: {
    trialFinishPhoto() {
      return `${process.env.BASE_URL || ''}img/trial-finish.svg`;
    },
    widthModal(): number {
      return window.innerWidth < 1025 && window.innerWidth > 767 ? 659 : 856;
    },
  },
  async mounted() {
    if (await Enrollments.isInTrial()) {
      setTimeout(
        async () => {
          this.isActive = true;

          if (await Enrollments.isInTrialTracking()) {
            Enrollments.finishTrialAndRemoveAccess(this.$store.getters.currentUser.id);
            this.$store.commit('SIGNOUT');
          }
        },
        await Enrollments.getTimeToEndOfTrial(),
      );
    }
  },
  methods: {
    goToHome(): void {
      window.open(process.env.VUE_APP_LAP_URL, '_self');
    },
    goToEnrollments(): void {
      window.open(process.env.VUE_APP_ENROLLMENTS, '_self');
    },
  },
});
